import { render, staticRenderFns } from "./Airplane.vue?vue&type=template&id=4faab748&functional=true&"
import script from "./Airplane.vue?vue&type=script&lang=js&"
export * from "./Airplane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports